import { useNavigate} from "react-router-dom";
import MenuLogo from "../../src/menu logo.svg";
import { useState, useEffect, useRef} from "react";
import Logo from "../../src/elmanassa logo.png"

export default function LogInNavBar({active , setActive, pagesOut, setPagesOut}){
    const [indicatorStyle, setIndicatorStyle] = useState({
        backgroundColor:"red;"
    });
  const navRefs = useRef({});
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const buttonClicked = (index)=>{
    console.log(index);
    setPagesOut({
      logInOut: index!==4,
      homeOut: index !==3,
      servicesOut: index !==2,
      contactUs: index !== 1,
      plansOut: index !== 0
    })
  }

  const navItems = ["خطط الاسعار", "تواصل معنا", "خدماتنا","الرئيسية","تسجيل الدخول"];
  const routes = ["plans", "contact-us", "services","","logIn"];



  useEffect(() => {
    const current = navRefs.current[active];
    if (current) {
      setIndicatorStyle({
        left: current.offsetLeft + "px",
        top: current.offsetTop + current.offsetHeight + "px",
        width: current.offsetWidth + "px",
        height: '1px',
        // height: current.offsetHeight + "px",
      });
    }
  }, [active]);


  return (
    <div>
    <nav className={`log-in-nav`}>
      
      <div className="log-in-nav-buttons">
        <div className="indicator" style={indicatorStyle}></div>
        {navItems.map((item,index) => (
        <button
          style={index===4?{
            backgroundColor:"#79f3ff"
          }:{}}
          key={item}
          ref={(el) => (navRefs.current[item] = el)}
          onClick={() => {
            setActive(item);
            buttonClicked(index);
            navigate(`/${routes[index]}`);
             }}
        >
          {item}
        </button>
      ))}
      <img className="showed-items-in-mobile-nav elmanassa-mobile-logo" src={Logo} alt="not found"/>
      </div>
      
        <div className="indicator" style={indicatorStyle}></div>
      <h1 className="hidden-items-in-mobile-nav" style={{fontSize:"2em",textAlign:"center"}}>  منصة تفوَّق التعليمية</h1>
      <img className="elmanassa-log" src={Logo} alt="not found"/>
      
    </nav>
    </div>
  );
}